import { render, staticRenderFns } from "./FormClient.vue?vue&type=template&id=d7aa82a4"
import script from "./FormClient.vue?vue&type=script&lang=ts"
export * from "./FormClient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports